/**
 * MDM action icons — pure lucide map keyed by catalog id. Spec §5.5.
 *
 * Duplicated from apps/web per spec §6.2. Keep in sync.
 *
 * Missing-id fallback: `Command`. Consumers apply the fallback so a newly
 * catalog-shipped command still renders an icon.
 */
import {
  AlertTriangle,
  ArrowLeftRight,
  Cable,
  Camera,
  CloudDownload,
  CloudOff,
  Command,
  Download,
  ExternalLink,
  Globe,
  HardDrive,
  History,
  Info,
  MonitorSmartphone,
  Package,
  Power,
  RefreshCw,
  RotateCw,
  Send,
  Terminal,
  UploadCloud,
  Wifi,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { MdmCommandId } from '@staff-app/shared-types';

export const MDM_ACTION_ICONS: Record<MdmCommandId, LucideIcon> = {
  IDENTIFY_SCREEN: MonitorSmartphone,
  MDM_REBOOT: Power,
  MDM_REFRESH: RefreshCw,
  MDM_CAPTURE_SCREENSHOT: Camera,
  MDM_TOGGLE_REMOTE_CONTROL: ArrowLeftRight,
  MDM_OPEN_REMOTE_VIEWER: ArrowLeftRight,
  MDM_HDMI_CEC: Cable,
  MDM_RS232: Send,
  MDM_GET_USED_STORAGE: HardDrive,
  MDM_INSTALL_OPTISIGNS_VERSION: Package,
  MDM_DISABLE_AUTOUPDATE: CloudOff,
  MDM_ENABLE_AUTOUPDATE: CloudDownload,
  MDM_INSTALL_APK: Download,
  MDM_OTA_UPDATE: UploadCloud,
  MDM_EXECUTE_REMOTE_COMMAND: Terminal,
  MDM_SET_TIMEZONE: Globe,
  MDM_WIFI_MANAGEMENT: Wifi,
  MDM_VIEW_DEVICE_INFO: Info,
  MDM_COMMAND_HISTORY: History,
  // Platform-api (Phase A)
  MDM_SYNC_NOW: RotateCw,
  MDM_OPEN_EXTERNAL_ADMIN: ExternalLink,
  MDM_VIEW_ISSUES: AlertTriangle,
};

/** Safe lookup — returns `Command` if the id is unknown to the client. */
export function getIcon(id: MdmCommandId): LucideIcon {
  return MDM_ACTION_ICONS[id] ?? Command;
}
